import { TypographyOptions } from '@mui/material/styles/createTypography'

declare module '@mui/material/styles' {
  interface TypographyVariants {
    title: React.CSSProperties
    titleLight: React.CSSProperties
    subtitle: React.CSSProperties
    textLight: React.CSSProperties
    text: React.CSSProperties
    textBold: React.CSSProperties
    textSmall: React.CSSProperties
    fontAwesomeIcon: React.CSSProperties
    fontAwesomeIconBold: React.CSSProperties
    pageTitle: React.CSSProperties
    breadcrumbItem: React.CSSProperties
    listItemLink: React.CSSProperties
    userProfileTitle: React.CSSProperties
    userProfileSubtitle: React.CSSProperties
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    title?: React.CSSProperties
    titleLight?: React.CSSProperties
    subtitle?: React.CSSProperties
    textLight?: React.CSSProperties
    text?: React.CSSProperties
    textBold?: React.CSSProperties
    textSmall?: React.CSSProperties
    fontAwesomeIcon?: React.CSSProperties
    fontAwesomeIconBold?: React.CSSProperties
    pageTitle?: React.CSSProperties
    breadcrumbItem?: React.CSSProperties
    listItemLink?: React.CSSProperties
    userProfileTitle?: React.CSSProperties
    userProfileSubtitle?: React.CSSProperties
  }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    title: true
    titleLight: true
    subtitle: true
    textLight: true
    text: true
    textBold: true
    textSmall: true
    fontAwesomeIcon: true
    fontAwesomeIconBold: true
    pageTitle: true
    breadcrumbItem: true
    listItemLink: true
    userProfileTitle: true
    userProfileSubtitle: true
  }
}

export const defaultThemeTypographyOptions: TypographyOptions = {
  fontFamily: 'var(--lato-font)',
  fontSize: 11.382,
  button: {
    textTransform: 'none'
  },
  title: {
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '15px',
    lineHeight: '18px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  titleLight: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '15px',
    lineHeight: '18px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  subtitle: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '14px',
    textOverflow: 'ellipsis'
  },
  textLight: {
    fontWeight: 400,
    fontSize: '10px',
    lineHeight: '12px'
  },
  text: {
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '16px',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  textBold: {
    fontWeight: 700,
    fontSize: '13px',
    lineHeight: '16px'
  },
  textSmall: {
    fontWeight: 400,
    fontSize: 9
  },
  fontAwesomeIcon: {
    fontWeight: 400,
    fontSize: '13px'
  },
  fontAwesomeIconBold: {
    fontWeight: 700,
    fontSize: '11px'
  },
  h1: {
    fontWeight: 400,
    fontSize: '25px',
    lineHeight: '34px'
  },
  h2: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '17px'
  },
  pageTitle: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '48px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  listItemLink: {
    fontWeight: 400,
    fontSize: '14px'
  },
  overline: {
    lineHeight: '1em'
  },
  breadcrumbItem: {
    fontSize: '11px',
    lineHeight: '1em'
  },
  userProfileTitle: {
    fontSize: '20px',
    lineHeight: 1
  },
  userProfileSubtitle: {
    fontSize: '10px',
    lineHeight: 1,
    textTransform: 'uppercase'
  }
}
